var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('mypage',{scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('face-to-face-table',{attrs:{"filterPic":""}})]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }